import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-3';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(TawkMessengerVue, {
        propertyId : '5c28eac87a79fc1bddf2b529',
        widgetId : '1ioqelon8'
    });
});